import React from "react";

function Card({ title, subtitle, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "100%",
        textAlign: "left",
        padding: 24,
        borderRadius: 20,
        border: "1px solid #e5e7eb",
        background: "#fff",
        boxShadow: "0 10px 30px rgba(15,23,42,0.08)",
        cursor: "pointer",
      }}
    >
      <div style={{ fontSize: 24, fontWeight: 800, color: "#111827" }}>{title}</div>
      <div style={{ marginTop: 8, color: "#6b7280", fontSize: 15 }}>{subtitle}</div>
    </button>
  );
}

export default function ModuleSelectPage({ onPickPohrebka, onPickUdrzba, onPickPohrebka2, onLogout }) {
  return (
    <div style={{ minHeight: "100vh", background: "#f3f4f6", padding: 24 }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div
          style={{
            background: "linear-gradient(135deg, #111827 0%, #1f2937 100%)",
            color: "#fff",
            borderRadius: 24,
            padding: 28,
            boxShadow: "0 18px 40px rgba(17,24,39,0.22)",
            marginBottom: 22,
          }}
        >
          <div style={{ fontSize: 32, fontWeight: 900 }}>PS Pohřebka</div>
          <div style={{ marginTop: 8, opacity: 0.92 }}>
            Vyber, do kterého systému chceš vstoupit
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 18,
          }}
        >
          <Card
            title="Pohřebka"
            subtitle="Hlavní systém pro zakázky pohřební služby, výjezdy, kalendář, dokumenty a evidenci."
            onClick={onPickPohrebka}
          />
          <Card
            title="Údržba hrobů CK"
            subtitle="Samostatná odnož pro zakázky údržby hrobů, ceník, přehled plateb a účetní podklady."
            onClick={onPickUdrzba}
          />
            <Card
              title="Pohřebka 2"
              subtitle="Nová čistá větev hlavního systému. Oddělené od staré Pohřebky, připravené pro nový vývoj."
              onClick={onPickPohrebka2}
            />
        </div>

        <div style={{ marginTop: 20 }}>
          <button
            onClick={onLogout}
            style={{
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid #d1d5db",
              background: "#fff",
              cursor: "pointer",
              fontWeight: 700,
            }}
          >
            Odhlásit
          </button>
        </div>
      </div>
    </div>
  );
}
